import React from "react";
import { Col, Form, message, Modal, Row, Skeleton, Tooltip } from "antd";

import FormInput from "components/FormInput/FormInput";
import SectionCard from "components/SectionCard/SectionCard";

import { TooltipIcon, DescriptionForLabel } from "./QuickManageModal.styles";
import Locale from "react-intl-universal";

const { useForm } = Form;
const tipsDescription = (
  <span>
    <b>Monthly Income Strength Indicator Threshold</b> is a ratio of expenses
    and incomes.
  </span>
);

const QuickManageModal = ({
  defaultValues,
  isLoading,
  onOk,
  onCancel,
  visible,
}) => {
  const [form] = useForm();
  const intialValues = {
    ...defaultValues,
    strengthIndicator: defaultValues.strengthIndicator * 100,
    income: {
      overridingTotal: {
        self: defaultValues.inflow && defaultValues.inflow.self,
        spouse: defaultValues.inflow && defaultValues.inflow.spouse,
      },
    },
    expenses: {
      overridingTotal: {
        self:
          defaultValues.outflow &&
          (defaultValues.outflow.self - defaultValues.monthlyPremium).toFixed(
            2
          ),
        spouse: defaultValues.outflow && defaultValues.outflow.spouse,
      },
    },
  };

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      const newValues = {
        ...values,
        strengthIndicator: values.strengthIndicator / 100,
      };
      onOk(newValues);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <Modal
      title={Locale.get("cashFlowSummary.cashFlowManagement")}
      visible={visible}
      okText={Locale.get("cashFlowSummary.saveButton")}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
      width="80%"
    >
      <Form form={form} initialValues={intialValues}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={24}>
                <FormInput
                  label={
                    <span>
                      {Locale.get("cashFlowSummary.thresholdMonthlyIncome")}{" "}
                      <Tooltip
                        placement="topLeft"
                        title={
                          <>
                            <b>
                              {Locale.get(
                                "cashFlowSummary.thresholdMonthlyIncome"
                              )}
                            </b>{" "}
                            {Locale.get("cashFlowSummary.toolTipDesc")}
                          </>
                        }
                      >
                        <TooltipIcon />
                      </Tooltip>
                    </span>
                  }
                  name="strengthIndicator"
                  placeholder="80"
                  suffix="%"
                  extraProps={{
                    type: "number",
                  }}
                  requiredErrorMessage={Locale.get(
                    "cashFlowSummary.errMsgIndicator"
                  )}
                />
              </Col>
              <Col span={12}>
                <SectionCard title={Locale.get("cashFlowSummary.self")}>
                  <Row>
                    <Col span={24}>
                      <FormInput
                        label={Locale.get("cashFlowSummary.tCashInflow")}
                        name={["income", "overridingTotal", "self"]}
                        placeholder="0.00"
                        type="financial"
                      />
                    </Col>
                    <Col span={24}>
                      <FormInput
                        label={
                          <>
                            {Locale.get("cashFlowSummary.tCashOutflow")}{" "}
                            <DescriptionForLabel>
                              ({Locale.get("cashFlowSummary.exMonthlyPremium")})
                            </DescriptionForLabel>
                          </>
                        }
                        name={["expenses", "overridingTotal", "self"]}
                        placeholder="0.00"
                        type="financial"
                        requiredErrorMessage={Locale.get(
                          "cashFlowSummary.errMsgCashOutflow"
                        )}
                      />
                    </Col>
                  </Row>
                </SectionCard>
              </Col>
              <Col span={12}>
                <SectionCard title={Locale.get("cashFlowSummary.spouse")}>
                  <Row>
                    <Col span={24}>
                      <FormInput
                        label={Locale.get("cashFlowSummary.tCashInflow")}
                        name={["income", "overridingTotal", "spouse"]}
                        placeholder="0.00"
                        type="financial"
                      />
                    </Col>
                    <Col span={24}>
                      <FormInput
                        label={Locale.get("cashFlowSummary.tCashOutflow")}
                        name={["expenses", "overridingTotal", "spouse"]}
                        placeholder="0.00"
                        type="financial"
                      />
                    </Col>
                  </Row>
                </SectionCard>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default QuickManageModal;
